import type { WrappedFieldInputProps, WrappedFieldMetaProps } from 'redux-form';
import { useAdminDispatch } from 'admin/reducers';

const noop = () => {};

type Params = {
	/** Names the control for its id; no form by this name has to exist */
	form: string;
	name: string;
	value: unknown;
	onChange: (value: unknown) => void;
};

/**
 * The `input` and `meta` a PropField control takes from redux-form, for a control that edits a value outside the card
 * form, such as one entry of a background layer list or a gradient's repeat.
 */
export function useStandaloneField({ form, name, value, onChange }: Params): {
	input: WrappedFieldInputProps;
	meta: WrappedFieldMetaProps;
} {
	const dispatch = useAdminDispatch();
	return {
		input: { name, value, onChange, onBlur: noop, onFocus: noop, onDragStart: noop, onDrop: noop },
		meta: {
			form,
			dispatch,
			autofilled: false,
			asyncValidating: false,
			dirty: false,
			initial: undefined,
			invalid: false,
			pristine: true,
			submitting: false,
			submitFailed: false,
			touched: false,
			valid: true,
			visited: false,
		},
	};
}
